import $ from 'jquery';
import View from 'mixins/view';

export default class extends View {
    constructor(model) {
        super(model);

        this.text = model.get('textContent');
        this.textLimit = 500;
        this.expandedText = false;

        const html = '<div class="comment-text"></div>';
        this.setRootEl($(html));
    }
    isMainComment() {
        return !(!!this.model.get('parentCommentId'));
    }
    isExpandedText() {
        return this.expandedText;
    }
    expand() {
        if (!this.isExpandedText()) {
            this.toggle();
        }
    }
    collapse() {
        if (this.isExpandedText()) {
            this.toggle();
        }
    }
    toggle() {
        this.expandedText = !this.expandedText;
        this.render();
    }
    buildButton() {
        let text = '';
        if (this.isMainComment()) {
            text = this.isExpandedText() ? 'Zwiń komentarz' : 'Rozwiń komentarz';
        } else {
            text = this.isExpandedText() ? 'Zwiń odpowiedź' : 'Rozwiń odpowiedź';
        }

        const html = `<span class="ct-show-more"> ${text} </span>`;
        const $button = $(html);

        $button.on('click', () => {
            this.toggle();
        });
        return $button;
    }
    isTextTooLong() {
        return (this.text.length > this.textLimit);
    }
    generateText() {
        let text = this.text;
        if (this.isTextTooLong()) {
            if (!this.isExpandedText()) {
                text = text.substring(0, this.textLimit);
                text += ' ... ';
            }
        }
        return text;
    }
    render() {
        const text = this.generateText();

        this.getRootEl().empty();
        this.getRootEl().append(text);

        if (this.isTextTooLong()) {
            const $button = this.buildButton();
            this.getRootEl().append($button);
        }
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comment-content-text-view.js